/**
 * The file re-exports `withRouter` to provide continuinty with current code
 * while migrating to TypeScript.  Even though consumers could import `withRouter`
 * directly from `react-router-dom`, this file also provides necessary helper types.
 */
// eslint-disable-next-line no-restricted-imports
import {withRouter, type RouteComponentProps} from "react-router-dom";

export default withRouter;

export type WithRouterProps = RouteComponentProps;
export type WithoutRouter<T> = Omit<T, keyof RouteComponentProps>;

export type Match = RouteComponentProps<Record<string, string>>["match"];
export type Location = WithRouterProps["location"];
